import { Box, Text, RadioGroup, Button, Radio, Flex } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useCicoSigninMutation } from "apis";
import { selectForm, setCicoAuthCheck } from "store/slices";
import { createSiweMessage, showFirstLastChar } from "utils";
import CopyButton from "components/Button/Copy";
import { useCopy, useWallet } from "hooks";
import ls from "utils/secureStorage";
import configs from "config";

interface IProps {
  isConnected: boolean;
  haveMetamask: boolean;
  defaultChecked: string;
  handleRadioTab: (e: string) => void;
  handleDisconnect: () => void;

  tabData: {
    label: string;
    value: string;
    index: number;
  }[];

  cicoAuthCheck: boolean;
}
const CicoTabAddress = ({
  haveMetamask,
  isConnected,
  tabData,
  cicoAuthCheck,
  handleRadioTab,
  defaultChecked,
  handleDisconnect,
}: IProps) => {
  const dispatch = useDispatch();
  const [_cicoAuth, { isLoading }] = useCicoSigninMutation();

  const { provider, chainId } = useWallet();
  console.log(chainId, "CHAIN ID");

  const signInWithEthereum = async () => {
    const signer = await provider?.getSigner();
    const address = signer.address;

    const message = createSiweMessage({
      address: address,
      statement: address,
    });

    const signature = await signer?.signMessage(message);

    const res: any = await _cicoAuth({
      message,
      signature,
      address,
    });

    if (res.data) {
      dispatch(setCicoAuthCheck(true));
      ls.set(configs.CICO_TOKEN_KEY, res.data.token);
      window.location.replace("/cico");
    }
  };

  const { walletAddress, walletAmount } = useSelector(selectForm);
  const { onCopy } = useCopy(walletAddress);

  const _auth = ls.get(configs.CICO_TOKEN_KEY);

  return (
    <Box mt="16px" display={{ base: "none", "3sm": "block" }}>
      <Box>
        {isConnected && haveMetamask && (
          <>
            <Box>
              <Box
                width="320px"
                height="150px"
                borderRadius="8px"
                padding="16px"
                bg="#F2F4F3"
                boxShadow="0px 2px 8px rgba(229, 229, 229, 0.47)"
                border="0.5px solid #CACBCB"
              >
                <Text fontSize="14px" fontWeight="500">
                  Wallet Balance
                </Text>

                <Text fontSize="32px" fontWeight="700">
                  {walletAmount ? walletAmount : 0} USD <br />
                </Text>

                <Box mt="24px">
                  <Flex onClick={onCopy} alignItems="center">
                    <Text fontWeight="500">
                      Address:{" "}
                      <Text as="span" fontWeight="700">
                        {showFirstLastChar(walletAddress, 6)}
                      </Text>
                    </Text>

                    <CopyButton />
                  </Flex>
                </Box>
              </Box>
            </Box>

            <Box m="24px 0">
              {isConnected && haveMetamask && (
                <Flex gridGap="12px">
                  {!cicoAuthCheck && (
                    <Button borderRadius="10px" minH="48px" isLoading={isLoading} minW="auto" onClick={signInWithEthereum}>
                      Sign In
                    </Button>
                  )}

                  <Button
                    _hover={{ background: "#fd774f" }}
                    bg="accent.default"
                    minH="48px"
                    minW="120px"
                    onClick={handleDisconnect}
                    borderRadius="10px"
                  >
                    Disconnect
                  </Button>
                </Flex>
              )}
            </Box>

            <Box
              bg="#F8F9F9"
              boxShadow="0px 2px 8px rgba(229, 229, 229, 0.47)"
              border="0.5px solid #CACBCB"
              maxW="320px"
              borderRadius="8px"
              width="100%"
              p={{ base: "0", md: "14px 16px 24px" }}
            >
              <RadioGroup value={defaultChecked} onChange={handleRadioTab}>
                {tabData.map(({ label, value }) => {
                  return (
                    <Box fontWeight="500" key={label} color="#000" borderBottom="0px solid #DBDBDB" padding="12px 8px 8px" mb="8px">
                      <Radio
                        isDisabled={!_auth && value !== "quotes" ? true : false}
                        value={value}
                        colorScheme="green"
                        width="100%"
                      >
                        {label}
                      </Radio>
                    </Box>
                  );
                })}
              </RadioGroup>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
export default CicoTabAddress;
